import { Fragment } from 'react';
import FormSearchPerson, { FormSearchPersonProps } from './form';
import { __PERSON_API_URL__ } from 'shell/constants/environment';
import { PersonalDataVM } from 'shell/view-models/personal-data';
import PmiTitle from '../title';
import { noop } from 'shell/utils/noop';

export interface SearchPersonSipoProps extends Partial<FormSearchPersonProps> {
  url?: string;
  onSuccess?: (item: PersonalDataVM) => void;
  onSipoPersonSelected?: (item?: PersonalDataVM) => void;
  goBackUrl?: string;
  addedTitle?: string;
}

const SearchPersonSipo = ({
  url = `${__PERSON_API_URL__}/non-residenti/ricerca-intestatario-morte`,
  onSuccess = noop,
  goBackUrl = '/cancellazioni',
  onSipoPersonSelected = noop,
  addedTitle = 'Cancellazione per morte non residenti',
  initialValues,
}: SearchPersonSipoProps): React.ReactElement => {
  return (
    <Fragment>
      <PmiTitle title={`Ricerca Persona - ${addedTitle}`} />
      <FormSearchPerson
        onSipoPersonSelected={onSipoPersonSelected}
        url={url}
        onSuccess={onSuccess}
        goBackUrl={goBackUrl}
        initialValues={initialValues}
      />
    </Fragment>
  );
};

SearchPersonSipo.displayName = 'search person sipo component';

export default SearchPersonSipo;
